import React, { useState, useEffect } from 'react';

// Lightweight client-side gate for the second-tier portfolio. Not cryptographically
// private (CRA ships everything in the bundle) — it just keeps the extra projects off
// the front page. A real server-side gate comes with the Next.js migration.
const PasswordGate = ({ onUnlock }) => {
  const [unlocked, setUnlocked] = useState(false);
  const [password, setPassword] = useState('');
  const [error, setError] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem('portfolioUnlocked') === '1') {
      setUnlocked(true);
      onUnlock && onUnlock(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    const expected = process.env.REACT_APP_PORTFOLIO_PASSWORD;
    if (expected && password === expected) {
      sessionStorage.setItem('portfolioUnlocked', '1');
      setUnlocked(true);
      setError(false);
      onUnlock && onUnlock(true);
    } else {
      setError(true);
    }
  };

  const handleHide = () => {
    sessionStorage.removeItem('portfolioUnlocked');
    setUnlocked(false);
    setPassword('');
    onUnlock && onUnlock(false);
  };

  if (unlocked) {
    return (
      <div className="form-outline">
        <div style={{ marginTop: '1em' }}>
          <div className="portfolio-heading-text">Yeah! Thanks!</div>
        </div>
        <button
          style={{ display: 'block', marginTop: '1em' }}
          className="form-button"
          onClick={handleHide}
        >
          Hide
        </button>
      </div>
    );
  }

  return (
    <div className="form-outline">
      <div style={{ marginTop: '1em' }}>
        <div className="portfolio-heading-text">See the whole portfolio of work:</div>
      </div>
      <form className="form-container" onSubmit={handleSubmit}>
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="form-input"
        />
        <button type="submit" className="form-button">
          Show
        </button>
      </form>
      {error && (
        <div style={{ marginTop: '0.5em', color: 'red' }}>Incorrect password.</div>
      )}
    </div>
  );
};

export default PasswordGate;
